<template>
    <div class="page-container">
        <div class="tabbox">
            <div class="tabs">
                <div class="tab-item" :class="{actived:currentTab == 1}" @click="changeTab(1)">进货订单</div>
                <div class="tab-item" :class="{actived:currentTab == 2}" @click="changeTab(2)">提货订单</div>
            </div>
        </div>
        <div class="page-bottom">
            
            <div class="purchase-block" v-for="(item,index) in list" :key="index" @click="jumpDetail(item.orderId)">
                <div class="goods-bock">
                    <div class="item-top">
                        <span class="date">{{item.createTime | formatCreatetime}}</span>
                        <span class="status waiting">
                            {{
                                item.status == 1 ? '待确认' :
                                item.status == 2 ? '待审核' :
                                item.status == 5 || item.status == 7 ? '待发货' :
                                item.status == 6 ? '已发货' :
                                item.status == 9 ? '已取消' :
                                item.status == 10 ? '已完成' : 
                                item.status == 50 ? '失败' : ''
                            }}
                        </span>
                    </div>
                    <!-- 进货商品信息 -->
                    <template v-for="(gitem,gindex) in item.goodsList">
                        <div class="goods-info-block">
                            <img :src="gitem.picUrl" class="goods-pic">
                            <div class="goods-detail">
                                <div class="goods-name">
                                    <span>{{`${gitem.name} ${gitem.degree}度 ${gitem.capacity}`}}</span>
                                </div>
                                <div class="goods-sku">
                                    <span>{{gitem.unit == '箱' ? '整箱(6瓶)' : '单瓶'}}</span>
                                    <span>x{{gitem.num}}({{gitem.unit == '箱' ? '箱' : '瓶'}})</span>
                                </div>
                                <div class="caigou-price">{{ currentTab == 1 ? '采购价：¥' + gitem.price + '/瓶' : ''}}</div>
                            </div>
                        </div>
                        <!-- 赠送商品信息 -->
                        <!-- <div class="presentation-block" v-for="(zitem,zindex) in gitem.goodsArr" :key="zindex">
                            <div class="present-left">
                                <div class="goods-pic">
                                    <img :src="zitem.picUrl" alt="">
                                    <div class="tag">{{zitem.flag == 1 ? '赠送' : '奖励'}}</div>
                                </div>
                                <div class="goods-info">
                                    <div class="goods-name">{{`${zitem.name} ${zitem.degree}度 ${zitem.capacity}`}}</div>
                                    <div class="sku">整箱(6瓶)</div>
                                </div>
                            </div>
                            <div class="x">x{{zitem.num}}(箱)</div>
                        </div> -->
                    </template>
                    <!-- 该种酒总数 -->
                    <div class="goods-total" v-show="currentTab == 1">
                        <span class="total-num">总金额：¥{{item.amount}}</span>
                    </div>
                    <!-- 底部按钮行 -->
                    <div class="btn-line" v-if="currentTab == 2 && item.status == 6">
                        <div class="btn-item" @click.stop="goStrack(item.orderId)">查看物流</div>
                    </div>
                </div>
            </div>
            <!-- 数据为空 -->
            <van-empty v-show="list.length == 0" :image=nullImg description="暂无数据~" />
        </div>
        <!-- <div class="see-more">查看更多</div> -->
    </div>
</template>

<script>
import $http from '@/lib/request'
import config from '@/config'
import {Toast,Empty} from 'vant'

export default {
    data(){
        return {
            currentTab:1,//1 进货，2 提货,3 兑换
            list:[],
            nullImg:require('@/assets/icon-null.png'),
            page:1,
            limit:10,
            maxPage:1,
        }
    },
    components:{
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    methods:{
        scrollFn(){
            if (document.querySelector(".page-container").offsetHeight - window.pageYOffset - window.screen.height < 100 && this.page < this.maxPage) {
                this.page++;
                this.getData();
            }
        },
        changeTab(type){
            this.currentTab=type;
            this.list=[];
            this.getData();
        },
        getData(){
            $http({
                method:'post',
                data:{
                    type:this.currentTab,
                    page:this.page,
                    limit:this.limit
                },
                url:config.api.stockList
            }).then(res=>{
                if(res.errno == 0){
                    if(this.page == 1){
                        this.list=this.list=res.data.orderList;
                    }else{
                        this.list=this.list.concat(res.data.orderList);
                    }
                    this.maxPage=res.data.pages;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        jumpDetail(oid){
            if(this.currentTab == 1){//跳转进货详情
                this.$router.push({
                    name:'purchase-detail',
                    params:{
                        orderId:oid
                    }
                });
            }else if(this.currentTab == 2){//跳转提货详情
                this.$router.push({
                    name:'pickup-detail',
                    params:{
                        orderId:oid
                    }
                });
            }
            
        },
        goStrack(oid){
            this.$router.push({
                name:'order-tracking',
                params:{
                    orderId:oid
                }
            });
        }
    },
    activated(){
        let ctab=this.$route.params.currentTab;
        if(ctab){
            this.currentTab=ctab;
        }
        this.getData();
        window.addEventListener("scroll", this.scrollFn);
    },
    beforeDestroy(){
        window.removeEventListener("scroll", this.scrollFn);
    },
}
</script>

<style lang="scss" scoped>
@mixin flex-beteween{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
.page-container{
    padding: 0 10px;
    background:#f5f5f5;
    min-height: 100vh;
    padding-top: 65px;
    box-sizing: border-box;
    .tabbox{
        position: fixed;
        background: #fff;
        top:0;
        left:0;
        width:100vw;
        height:65px;
        box-sizing: border-box;
        padding: 12px 38px;
        z-index: 9;
        .tabs{
            overflow: hidden;
            display: flex;
            align-items: flex-start;
            justify-content: center;
            .tab-item{
                width:50%;
                height:40px;
                line-height: 40px;
                text-align: center;
                font-size: 16px;
                color:#2172F6;
                box-sizing: border-box;
                border:1px solid #3088F5;
                &.actived{
                    color:#fff;
                    background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
                    border:none;
                }
                &:first-child{
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                    border-right: none;
                }
                &:last-child{
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                    border-left: none;
                }
            }
        }
    }
    .page-bottom{
        padding:10px 0;
        .purchase-block{
            position: relative;
            .goods-bock{
                background:#fff;
                border-radius: 4px;
                padding:15px;
                padding-top: 0;
                box-sizing: border-box;
                margin-bottom: 10px;
                // &::after,&::before{
                //     content:'';
                //     display: block;
                //     width:20px;
                //     height:20px;
                //     border-radius: 50%;
                //     background:#f5f5f5;
                //     position: absolute;
                //     top:125px;
                // }
                // &::before{
                //     left:-10px;
                // }
                // &::after{
                //     right:-10px;
                // }
                .item-top{
                    @include flex-beteween();
                    height:44px;
                    line-height: 44px;
                    color:#999;
                    border-bottom: 1px solid #f5f5f5;
                    .date{
                        font-size: 13px;
                    }
                    .status{
                        font-size: 14px;
                        &.waiting{
                            color:#FFA820;
                        }
                    }
                }
                .goods-info-block{
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 15px;
                    .goods-pic{
                        width:80px;
                        height:80px;
                        margin-right: 10px;
                        border-radius: 4px;
                    }
                    .goods-detail{
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        width:calc(100% - 70px);
                        .goods-name{
                            &>span:first-child{
                                overflow: hidden;
                                text-overflow:ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            @include flex-beteween();
                            color:#000;
                            line-height: 20px;
                            font-size: 14px;
                        }
                        .goods-sku{
                            @include flex-beteween();
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                        .caigou-price{
                            color:#999;
                            line-height: 18px;
                            font-size: 12px;
                        }
                    }
                }
                .presentation-block{
                    position: relative;
                    margin-top: 30px;
                    @include flex-beteween();
                    .present-left{
                        width:280px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: flex-start;
                        .goods-pic{
                            width:50px;
                            height:50px;
                            border-radius: 4px;
                            overflow: hidden;
                            position: relative;
                            margin-right: 10px;
                            &>img{
                                display: block;
                                width:100%;
                                height:100%;
                            }
                            .tag{
                                padding:0 5px;
                                height:18px;
                                line-height: 18px;
                                background:#E43D3D;
                                color:#fff;
                                border-bottom-right-radius: 4px;
                                position: absolute;
                                top:0;
                                left:0;
                                font-size: 10px;
                            }
                        }
                        .goods-info{
                            width:220px;
                            height:50px;
                            display: flex;
                            justify-content: space-between;
                            flex-direction: column;
                            .goods-name{
                                font-size: 12px;
                                color:#000;
                                line-height: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .sku{
                                color:#999;
                                font-size: 10px;
                                line-height: 14px;
                            }
                        }
                    }
                    .present-right{
                        width:50px;
                        height:50px;
                        line-height: 50px;
                        font-size: 12px;
                        color: #999;
                        text-align: right;
                        position: relative;
                        border-left:1px solid #d8d8d8;
                        // &::after{
                        //     position: absolute;
                        //     top:10px;
                        //     left:0;
                        //     content:'';
                        //     display: block;
                        //     height:40px;
                        //     width:1px;
                        //     box-shadow: -1px 0px 3px 1px #d8d8d8;
                        //     background:transparent;
                        // }
                    }
                }
                .goods-total{
                    font-size: 14px;
                    color:#999;
                    text-align: right;
                    margin-top: 15px;
                    .total-num{
                        color:#3088F5;
                    }
                }
                .btn-line{
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    .btn-item{
                        width: 90px;
                        height: 30px;
                        line-height: 30px;
                        text-align: center;
                        background: #FFFFFF;
                        border-radius: 26px;
                        border: 1px solid #DCDADA;
                        color:#333;
                        font-size: 14px;
                    }
                }
            }
        }
        .see-account{
            color:#000;
            font-size: 16px;
            line-height: 22px;
            margin-top: 25px;
        }
    }
    .see-more{
        padding:10px;
        line-height: 18px;
        color:#999;
        text-align: right;
        font-size: 12px;
    }
}
</style>